module.exports = "/assets/data/5d5a2644bc948c4191e6ec1f870d7fd0-NG23.data.json";